import router from './router'
import store from './store'
import {Message} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth'
import { indexOf } from 'lodash'


NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/','/login', '/register','/mobile_phone', '/retrieve','/industry_information','/technology','/technology_detail','/environmental_housekeeper','/data_center','/data_detail', '/supply_demand','/supply_detail','/environmental_college','/environmental_college_detail','/corporate_detail','/activity_list','/activity_detail','/jicai_activity_list','/jicai_activity_detail','/expert_list','/expert_detail','/info_detail','/help_center','/help_detail','/classification_list','/corporate_detail','/demand_detail','/platform_entry','/contact_us','/chapter_users','/advertising_services','/searchIndex','/corporate_supply_all','/corporate_demand','/corporate_introduce','/corporate_list_all','/corporate_case_all','/corporate_qualifications','/summary_demand','/exhibition_detail','/curriculumDetail','/exhibition_list','/corporate_case_detail','/supply_project','/enterprise_interview_detail']  // 不重定向白名单
const scrollList = ['/income', '/demand', '/means', '/problem', '/download', '/collection', '/curriculum', '/activity', '/personal_information', '/password_change', '/membership', '/message','/corporate_case','/corporate_list','/corporate_supply','/corporate_account','/corporate_news','/corporate_attestation','/meansAdd','/meansDetail','/demandAdd','/demandDetail','/problemDetail']
router.beforeEach(async (to, from, next) => {
   // 启动进度条
  NProgress.start()
  const hasToken = getToken()

  // 判断 Token 是否存在
  if (hasToken) { //如果有token，说明是登录状态
    if (to.path === '/login') { //路由是/login页，那么直接跳转到首页
      next({ path: '/' })
      NProgress.done()  //进度条结束
    } else {   // 判断用户的角色是否存在
       const hasGetUserInfo = store.getters.userInfo
      if (hasGetUserInfo) { // 如果用户的角色存在，则直接访问
        next()
      } else {   // 如果用户的角色不存在
        try {
          // 异步获取用户的角色
          await store.dispatch('user/getInfo')
         next()
        } catch (error) {
          // 当获取用户 角色 和 获取路由 过程中产生异常时进行 catch 异常处理
          // 移除 Token 数据
          await store.dispatch('user/resetToken')
          // 显示提示错误
          Message.error(error || 'Has Error')
          // 重定向到 login 页面
          next(`/login?redirect=${to.path}`)
           // 停止进度条
          NProgress.done()
        }
      }
    }
  } else {
     /* 不存在 token*/
    // 判断访问的 URL 是否在白名单中
     if (whiteList.indexOf(to.path == '/'?to.path:to.path.replace(/\/$/g, '')) !== -1) {
         next()
      } else {
       // 如果访问的 URL 不在白名单中，则直接重定向到登录页面，并将访问的 URL 添加到 redirect 参数中
         next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
      // next()
  }
})


router.afterEach((to, from, next) => {
  // finish progress bar
  if (scrollList.indexOf(to.path) !== -1) {
    window.scrollTo(0, 660);
  } else {
    window.scrollTo(0, 0);
  }

  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js